<template>
  <div>
    <PageHeader title="รายงานข้อมูลนักเรียน"></PageHeader>
    <b-container class="mt-5">
      <div class="section-container">
        <div class="search-section">
          <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
          <b-row>
            <b-col cols="3">
              <label><strong>วันที่ลงทะเบียน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formatEnrollDate"
                    placeholder="เลือกวันที่ลงทะเบียน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('enroll-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="enrollDate"
                  locale="th"
                  id="enroll-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
            <b-col cols="3">
              <label><strong>สถานะ</strong></label>
              <b-form-select
                v-model="selectedStatus"
                :options="statusList"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button @click="searchQuery()" class="search-btn" variant="primary">
            <b-icon icon="search"></b-icon>
            ค้นหาข้อมูล
          </b-button>
        </div>

        <div v-if="isShowTable" class="table-section">
          <div class="table-title">
            <p>
              <strong>รายละเอียดข้อมูลนักเรียน</strong> ข้อมูลทั้งหมด
              {{ studentInfoReportList.length }}
              ข้อมูล
            </p>
            <b-button @click="generatePdf()" variant="primary">
              <b-icon icon="chevron-double-down"></b-icon>
              ดาวน์โหลดรายงาน pdf
            </b-button>
          </div>
          <p class="remark-text">
            หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
            และดาวน์โหลดลงบนเครื่องของคุณ
          </p>
          <b-table
            id="student-info-report"
            :fields="fields"
            :items="studentInfoReportList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isDataTableLoading"
            hover
            bordered
            show-empty
          >
            <template slot="table-busy" class="text-center text-danger my-2">
              <Loading />
            </template>
            <template #empty>
              <p class="text-center py-3">ไม่มีข้อมูล</p>
            </template>
            <template v-slot:cell(studentName)="data">
              {{ data.item.firstName }} {{ data.item.lastName }}
            </template>
            <template v-slot:cell(enrollDate)="data">
              {{ data.item.registerDate | thaiDateFilter }}
            </template>
            <template v-slot:cell(dateOfBirth)="data">
              {{ data.item.dateOfBirth | thaiDateFilter }}
            </template>
          </b-table>
          <b-row class="mt-3" v-if="studentInfoReportList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ studentInfoReportList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="studentInfoReportList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="studentInfoReportList.length"
                  aria-controls="student-info-report"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import Loading from "@/components/shared/Loading";
import moment from "moment";
import generateAttendanceReportPdfMixin from "../../../mixins/generate-attendance-report-pdf-mixin";
import studentInfoReportMixin from "../../../mixins/student-info-report-mixin";

export default {
  mixins: [dateMixin, generateAttendanceReportPdfMixin, studentInfoReportMixin],
  components: { PageHeader, DatePicker, Loading },
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      enrollDate: {
        start: "",
        end: "",
      },
      selectedStatus: "all",
      statusList: [
        { value: "all", text: "สถานะทั้งหมด" },
        { value: "active", text: "เปิดใช้งาน" },
        { value: "inactive", text: "ระงับการใช้งาน" },
      ],
      isShowTable: false,
      isDataTableLoading: false,
      studentInfo: [],
      fields: [
        {
          label: "รหัสนักเรียน",
          key: "studentId",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ชื่อนักเรียน",
          key: "studentName",
        },
        {
          label: "วันที่ลงทะเบียน",
          key: "enrollDate",
        },
        {
          label: "โรงเรียน",
          key: "school",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "E-Mail",
          key: "email",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "บัตรประชาชน",
          key: "idCard",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "วันเดือนปีเกิด",
          key: "dateOfBirth",
        },
      ],
      perPage: 10,
      currentPage: 1,
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "l",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 20,
          r: 20,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("ReportManagement", ["studentInfoReportList"]),
    userInfo() {
      return JSON.parse(localStorage.getItem("user"));
    },
    currentProfile() {
      return this.getCurrentProfile(this.userInfo.profiles);
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
    formatEnrollDate() {
      return this.getFormattedRange(
        this.enrollDate.start,
        this.enrollDate.end,
        "enroll-date",
      );
    },
    selectedStatusText() {
      const selected = this.statusList.find(
        (item) => item.value === this.selectedStatus,
      );

      return selected ? selected.text : "สถานะทั้งหมด";
    },
  },
  mounted() {
    this.setDefaultDates();
  },
  methods: {
    ...mapActions("ReportManagement", ["fetchStudentInfoReportList"]),
    async fetch(params) {
      this.isDataTableLoading = true;
      try {
        await this.fetchStudentInfoReportList(params);
      } finally {
        this.isDataTableLoading = false;
      }
    },
    searchQuery() {
      let params = {
        status: this.selectedStatus,
        startDate: this.enrollDate.start
          ? moment(this.enrollDate.start).format("YYYY-MM-DD")
          : "",
        endDate: this.enrollDate.end
          ? moment(this.enrollDate.end).format("YYYY-MM-DD")
          : "",
      };

      console.log(params);
      this.fetch({
        comId: this.comId,
        attributes: params,
      });
      this.isShowTable = true;
    },
    getCurrentProfile(profiles) {
      const requestCompany = this.$route.params.company;
      if (requestCompany) {
        let currentCompany = profiles.find(
          (data) => data.company.url === requestCompany,
        );
        if (currentCompany) return currentCompany;
      } else if (localStorage.getItem("ComId")) {
        const currentComId = localStorage.getItem("ComId");
        let currentCompany = profiles.find(
          (data) => data.company.id == currentComId,
        );
        if (currentCompany) return currentCompany;
      }

      return profiles[0];
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();

      this.enrollDate.start = currentDate.format(dateFormat);
      this.enrollDate.end = currentDate.format(dateFormat);
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
